import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { SERVICES } from "@/data/services";

const ServiceCard = ({ s, index }) => {
  const Icon = s.icon;
  return (
    <Reveal delay={index * 0.06} className="h-full">
      <Link
        to={`/services/${s.slug}`}
        data-testid={`service-card-${index}`}
        className="group relative h-full flex flex-col bg-white border border-silver-200 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand-blue/40 hover:shadow-[0_18px_40px_rgba(10,17,40,0.08)]"
      >
        <div className="flex items-center justify-between">
          <span className="inline-flex h-12 w-12 items-center justify-center bg-silver-200 text-navy-900 transition-colors duration-300 group-hover:bg-brand-blue group-hover:text-white">
            <Icon size={22} />
          </span>
          <span className="text-sm font-black tracking-tight text-silver-300">
            0{index + 1}
          </span>
        </div>
        <h3 className="mt-7 text-xl font-bold text-navy-900 tracking-tight">{s.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-navy-700/70 flex-1">{s.excerpt}</p>
        <span className="mt-7 inline-flex items-center gap-1.5 text-sm font-bold text-navy-900 transition-colors duration-300 group-hover:text-brand-blue">
          Learn more
          <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </Link>
    </Reveal>
  );
};

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-silver py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <span className="eb-overline text-brand-blue">What We Do</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-[2.7rem] leading-[1.08] tracking-tight font-black text-navy-900">
                Full-spectrum advisory across the maritime lifecycle.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <button
              data-testid="services-cta"
              onClick={() => scrollToId("#contact")}
              className="inline-flex items-center gap-2 text-sm font-bold text-navy-900 hover:text-brand-blue transition-colors"
            >
              Discuss your requirement <ArrowUpRight size={17} />
            </button>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.slug} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
